"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _HotjarConnector = _interopRequireDefault(require("./connectors/HotjarConnector"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var triggerEvent = function triggerEvent(trigger) {
  _HotjarConnector.default.trigger(trigger);
};
var recordTag = function recordTag(tagsArray) {
  var tags = tagsArray instanceof Array ? tagsArray : [tagsArray];
  _HotjarConnector.default.recordTag(tags);
};
var _default = {
  triggerEvent: triggerEvent,
  recordTag: recordTag
};
exports.default = _default;
//# sourceMappingURL=HotjarTracking.js.map